function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M11.019,1.444v4.74a1.209,1.209,0,0,1-1.212,1.3L0,7.641V0L9.8.145A1.208,1.208,0,0,1,11.019,1.444Z",
  transform: "translate(7.551 0.758)",
  fill: "#d6dfe5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_123",
  "data-name": "Group 123",
  transform: "translate(18.469 1.646)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M0,0A1.489,1.489,0,0,1,.1.556V5.3a1.49,1.49,0,0,1-.1.556Z",
  fill: "#d44848"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M0,0A1.078,1.078,0,0,1,.1.315V4.694A1.039,1.039,0,0,1,0,5Z",
  transform: "translate(0 0.432)",
  fill: "#646c72"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M0,3.821C0,7.783,2.627,7.642,3.107,7.642H7.534c.366,0,.507-.335.507-.749V.75C8.041.336,7.9,0,7.534,0H3.107C2.627,0,0-.14,0,3.821Z",
  transform: "translate(0 0.757)",
  fill: "#d6dfe5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  d: "M1.854,0h.385A.078.078,0,0,1,2.3.122l0,0L2.282.145v0a3.564,3.564,0,0,0-.263.631A9.335,9.335,0,0,0,1.662,3.5a9.338,9.338,0,0,0,.356,2.72,3.635,3.635,0,0,0,.262.629l0,0,.01.018v0a.078.078,0,0,1-.056.123H1.854A1.793,1.793,0,0,1,.8,6.392,4.053,4.053,0,0,1,0,3.5,4.076,4.076,0,0,1,.8.6,1.852,1.852,0,0,1,1.854,0Z",
  transform: "translate(0.275 1.082)",
  fill: "#e9f0f4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_104",
  "data-name": "Path 104",
  d: "M0,0H7.027l.03,1.21a3.513,3.513,0,0,1-7.027,0Z",
  transform: "translate(3.281 8.083) rotate(-90)",
  fill: "#405d72"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_124",
  "data-name": "Group 124",
  transform: "translate(2.317 1.064)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  "data-name": "Path 77",
  d: "M2.039,0a.3.3,0,0,1-.3.307,3.136,3.136,0,0,1-1.1-.1L0,.034V6.124l.635-.176c.141-.039.083-.07,1.023-.093a.38.38,0,0,1,.382.387H2.4V0Z",
  transform: "translate(2.658 0.435)",
  fill: "#d6dfe5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M.665.144.653.162v0A3.478,3.478,0,0,0,.375.8,8.9,8.9,0,0,0,0,3.516a8.889,8.889,0,0,0,.375,2.72,3.523,3.523,0,0,0,.276.629l0,0,.011.018A.31.31,0,0,0,.812,7a.326.326,0,0,0,.205.01L1.053,7l1.535-.427h0l.069-.019V.47L2.59.451,1.024.012A.324.324,0,0,0,.665.144Z",
  fill: "#d6dfe5"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M4.384,5.307a.334.334,0,0,1-.319.339,9.644,9.644,0,0,0-2.083.462,12.472,12.472,0,0,1-1.358.268.025.025,0,0,1-.015,0L.6,6.365l0,0A3.23,3.23,0,0,1,.358,5.8,8.554,8.554,0,0,1,0,3.191,8.558,8.558,0,0,1,.358.578,3.135,3.135,0,0,1,.607.007L.61,0A.031.031,0,0,1,.63,0c.237.067.71.1,1.352.27A8.567,8.567,0,0,0,4.065.735a.333.333,0,0,1,.319.339Z",
  transform: "translate(2.611 1.389)",
  fill: "#e9f0f4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  d: "M11.533.851V4.146a.815.815,0,0,1-.861.849L0,4.961V.049L10.672,0A.815.815,0,0,1,11.533.851Z",
  transform: "translate(6.42 2.074)",
  fill: "#e9f0f4"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M2.193.375a.3.3,0,0,1,.2.334A18.917,18.917,0,0,0,2.212,3.28,19.037,19.037,0,0,0,2.4,5.851a.3.3,0,0,1-.2.334L.947,6.545a.317.317,0,0,1-.366-.158v0A3.325,3.325,0,0,1,.334,5.8,8.561,8.561,0,0,1,0,3.281,8.56,8.56,0,0,1,.334.759,3.3,3.3,0,0,1,.581.175v0a.32.32,0,0,1,.37-.16Z",
  transform: "translate(2.358 1.299)",
  fill: "#405d72"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M2.4.709A18.919,18.919,0,0,0,2.212,3.15a2.316,2.316,0,0,1-1.691.738A2.263,2.263,0,0,1,.014,3.83Q0,3.56,0,3.281A8.558,8.558,0,0,1,.334.759,3.314,3.314,0,0,1,.581.175v0a.32.32,0,0,1,.37-.16L2.193.375A.3.3,0,0,1,2.4.709Z",
  transform: "translate(2.357 1.299)",
  fill: "#949bb8",
  opacity: 0.5
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Group_129",
  "data-name": "Group 129",
  transform: "translate(0.589 1.358)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_125",
  "data-name": "Group 125",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  d: "M.937,0V.542A.648.648,0,0,1,.3,1.2H.181A.6.6,0,0,1,0,1.172,2.5,2.5,0,0,1,.523.324,1.9,1.9,0,0,1,.937,0Z",
  transform: "translate(0 0)",
  fill: "#405d72"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_127",
  "data-name": "Group 127",
  transform: "translate(0 5.24)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M.182,0H.3A.648.648,0,0,1,.937.658V1.2A1.906,1.906,0,0,1,.523.876,2.492,2.492,0,0,1,0,.027.605.605,0,0,1,.182,0Z",
  transform: "translate(0)",
  fill: "#405d72"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_126",
  "data-name": "Group 126",
  transform: "translate(0.275 0.047)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M.1.532c.054,0,.1-.119.1-.266S.151,0,.1,0,0,.119,0,.266.044.532.1.532Z",
  fill: "#f4e6c1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M.107.2A.468.468,0,0,0,.073.013a.022.022,0,0,0-.04,0A.467.467,0,0,0,0,.2a.467.467,0,0,0,.033.19.022.022,0,0,0,.04,0A.469.469,0,0,0,.107.2Z",
  transform: "translate(0.044 0.063)",
  fill: "#f4eddc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M.089.484C.138.484.177.375.177.242S.138,0,.089,0,0,.108,0,.242.04.484.089.484Z",
  transform: "translate(0.22 0.271)",
  fill: "#f4e6c1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M.07.248C.108.248.139.192.139.124S.108,0,.07,0,0,.056,0,.124.031.248.07.248Z",
  transform: "translate(0.431 0.687)",
  fill: "#f4bb92"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M.107.2A.465.465,0,0,0,.073.013a.022.022,0,0,0-.04,0A.467.467,0,0,0,0,.2a.468.468,0,0,0,.033.19.022.022,0,0,0,.04,0A.467.467,0,0,0,.107.2Z",
  transform: "translate(0.255 0.31)",
  fill: "#f4eddc"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_128",
  "data-name": "Group 128",
  transform: "translate(0.275 0.207)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M.1,0c.054,0,.1.119.1.266S.151.532.1.532,0,.413,0,.266.044,0,.1,0Z",
  transform: "translate(0 0.403)",
  fill: "#f4e6c1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M.107.2a.469.469,0,0,1-.033.19.022.022,0,0,1-.04,0A.467.467,0,0,1,0,.2.467.467,0,0,1,.033.013a.022.022,0,0,1,.04,0A.469.469,0,0,1,.107.2Z",
  transform: "translate(0.044 0.466)",
  fill: "#f4eddc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  d: "M.089,0C.138,0,.177.108.177.242S.138.484.089.484,0,.375,0,.242.04,0,.089,0Z",
  transform: "translate(0.22 0.18)",
  fill: "#f4e6c1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  "data-name": "Path 93",
  d: "M.07,0C.108,0,.139.055.139.124S.108.248.07.248,0,.192,0,.124.031,0,.07,0Z",
  transform: "translate(0.431 0)",
  fill: "#f4bb92"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  "data-name": "Path 94",
  d: "M.107.2a.466.466,0,0,1-.033.19.022.022,0,0,1-.04,0A.468.468,0,0,1,0,.2.468.468,0,0,1,.033.013a.022.022,0,0,1,.04,0A.466.466,0,0,1,.107.2Z",
  transform: "translate(0.255 0.219)",
  fill: "#f4eddc"
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "Group_130",
  "data-name": "Group 130",
  transform: "translate(4.448 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  d: "M.366.048v.64a.187.187,0,0,1-.183.19H.142A.145.145,0,0,1,0,.731v-.4A.327.327,0,0,1,.32,0h0A.048.048,0,0,1,.366.048Z",
  transform: "translate(0)",
  fill: "#d6dfe5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_96",
  "data-name": "Path 96",
  d: "M.366.83V.19A.187.187,0,0,0,.183,0H.142A.145.145,0,0,0,0,.147v.4A.327.327,0,0,0,.32.878h0A.047.047,0,0,0,.366.83Z",
  transform: "translate(0 8.278)",
  fill: "#d6dfe5"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  d: "M.136.057A.07.07,0,0,1,.275.07V2.992a.07.07,0,0,1-.139.015A7.246,7.246,0,0,1,0,1.531,7.238,7.238,0,0,1,.136.057Z",
  transform: "translate(0 3.047)",
  fill: "#4e5251"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M4.842.741.365.729A.366.366,0,0,1,0,.365H0A.366.366,0,0,1,.365,0L4.842.012a.366.366,0,0,1,.365.365h0A.366.366,0,0,1,4.842.741Z",
  transform: "translate(6.996 1.095)",
  fill: "#405d72"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M4.287.772.365.729A.366.366,0,0,1,0,.365H0A.366.366,0,0,1,.365,0L4.287.043a.366.366,0,0,1,.364.365h0A.366.366,0,0,1,4.287.772Z",
  transform: "translate(12.497 1.114)",
  fill: "#405d72"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M4.977,0,.365.015A.366.366,0,0,0,0,.38H0A.366.366,0,0,0,.365.745L4.977.729A.366.366,0,0,0,5.341.365h0A.366.366,0,0,0,4.977,0Z",
  transform: "translate(6.861 7.352)",
  fill: "#405d72"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M4.287,0,.365.043A.366.366,0,0,0,0,.408H0A.366.366,0,0,0,.365.772L4.287.729A.366.366,0,0,0,4.651.365h0A.366.366,0,0,0,4.287,0Z",
  transform: "translate(12.497 7.303)",
  fill: "#405d72"
});

var SvgCarIcon = function SvgCarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_141",
    "data-name": "Group 141",
    width: 18.57,
    height: 9.156,
    viewBox: "0 0 18.57 9.156",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carIcon.23adf1e8.svg";
export { ForwardRef as ReactComponent };